export const getCanManageAnalysis = ({
  isAdmin,
  currentUserId,
  ownerId
}: {
  isAdmin: boolean;
  currentUserId: string;
  ownerId?: string | null;
}): boolean => isAdmin || (!!ownerId && ownerId === currentUserId);
